import { getIn } from "formik";
import { useState } from "react";
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffOutline } from "react-icons/io5";

const TextInput = ({
  label,
  placeholder,
  name,
  number,
  formik,
  type = "text",
  disabled,
  onChange,
  showError,
  onBlur,
  icon,
}) => {
  const required = Object.keys(formik.initialValues).some((key) => key === name);
  const nestedError = getIn(formik.errors, name);
  const nestedTouched = getIn(formik.touched, name);
  const handleKeyDown = (e) => {
    if (
      number &&
      !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(e.key) &&
      !/^[0-9]$/.test(e.key)
    ) {
      e.preventDefault();
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="relative w-full dark:text-white">
      {label && (
        <label className="block mb-1 font-semibold capitalize text-primary">
          {label} {required && <span className="text-mainRed">*</span>}
        </label>
      )}
      <div className="border-primary border  rounded-[12px] overflow-hidden flex items-center gap-1 px-2 bg-sideBar">
        {icon ? icon : null}
        <input
          type={type === "password" && showPassword ? "text" : type}
          name={name}
          placeholder={placeholder}
          onChange={onChange || (formik && formik.handleChange)}
          onBlur={onBlur || (formik && formik.handleBlur)}
          value={formik.getFieldProps(name)?.value || ""}
          disabled={disabled}
          className="w-full px-2 py-2 bg-transparent h-14 focus-visible:outline-none"
          autoComplete="off"
          onKeyDown={handleKeyDown}
        />
        {type === "password" && (
          <span className="cursor-pointer" onClick={() => setShowPassword((s) => !s)}>
            {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
          </span>
        )}
        {(showError || !disabled) && nestedError && (showError || nestedTouched) && (
          <span className="text-[12px] text-mainRed absolute bottom-[-18px]">
            {nestedError}
          </span>
        )}
      </div>
    </div>
  );
};

export default TextInput;
